module.exports = __webpack_public_path__ + "img/step-4.b02f03ce.jpg";